import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncRecentTravelerActivity = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "recent-traveler-activity" */
        /* webpackPreload: true */
        './RecentTravelerActivity'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
